import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { ordersQueryKeys } from '@modules/orders/api/ordersQueryKeys'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { checkTrustlineStatus } from '../cryptoWalletsEndpoints'
import type { TrustlineActionInput } from '../../types/cryptoWalletTypes'

/**
 * Re-reads a submitted trustline from the XRPL ledger and applies what it says.
 *
 * The follow-up to a setup that came back `pending`: admin-service stops waiting
 * after ~15s, but the transaction usually validates seconds later, so this is
 * how a pending row becomes active without another TrustSet being submitted.
 */
export function useCheckTrustlineStatusMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: TrustlineActionInput) => checkTrustlineStatus(input),
    onSettled: (_result, _error, input) => {
      queryClient.invalidateQueries({
        queryKey: cryptoWalletsKeys.walletManagementDetail(input.investorId),
      })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.walletManagementLists() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.lists() })
      // The wallet detail's trustline-gap list is a fold over the investor's
      // orders, each carrying its own joined trustline status — so the orders
      // cache is as stale as the wallet one after this call.
      queryClient.invalidateQueries({ queryKey: ordersQueryKeys.lists() })
    },
  })
}
